/* Coffee for Humans — Phase 2B conversion tracking hooks.
   Uses existing storefront pixels only. No new external endpoints. */
(function () {
  'use strict';

  var seen = Object.create(null);

  function normalizePayload(payload) {
    var out = payload || {};
    out.page_path = window.location.pathname;
    out.page_title = document.title;
    return out;
  }

  function track(name, payload) {
    var data = normalizePayload(payload);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, cfh: data });

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, data);
    }

    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', name, data);
    }

    window.dispatchEvent(new CustomEvent('cfh:track', { detail: { event: name, payload: data } }));
  }

  window.cfhTrack = track;

  function textOf(node) {
    return (node && (node.innerText || node.textContent) || '').trim().replace(/\s+/g, ' ').slice(0, 160);
  }

  function productHandleFromUrl(url) {
    try {
      var path = new URL(url, window.location.origin).pathname;
      var match = path.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    } catch (e) {
      return '';
    }
  }

  function fireOnce(key, name, payload) {
    if (seen[key]) return;
    seen[key] = true;
    track(name, payload);
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('a, button');
    if (!target) return;

    if (target.matches('[data-cfh-start]')) {
      track('cfh_quiz_start', { source: 'find_my_coffee' });
      return;
    }

    if (target.matches('.cfh-live-quiz__answer')) {
      track('cfh_quiz_answer', { answer: textOf(target) });
      return;
    }

    if (target.matches('[data-cfh-open-popup]')) {
      track('cfh_quiz_email_prompt_click', { source: 'quiz_result' });
      if (typeof window.cfhShowPopup === 'function') window.cfhShowPopup('quiz_result');
      return;
    }

    if (target.matches('#checkout, .cart__checkout-button')) {
      track('cfh_begin_checkout_click', { source: 'cart_drawer' });
      return;
    }

    if (target.matches('button[name="add"], .add-to-cart-button') || /add to cart/i.test(textOf(target))) {
      track('cfh_add_to_cart_click', {
        product_handle: productHandleFromUrl(window.location.href),
        source: window.location.pathname.indexOf('/products/') === 0 ? 'pdp' : 'quick_add'
      });
      return;
    }

    if (target.matches('.cfh-product-card-link') || /view coffee/i.test(textOf(target))) {
      track('cfh_product_card_click', {
        product_handle: productHandleFromUrl(target.href || target.closest('a')?.href || ''),
        source: 'collection_or_recommendations'
      });
      return;
    }

    if (target.matches('.cfh-live-quiz--result a[href*="/products/"]')) {
      track('cfh_quiz_result_product_click', {
        product_handle: productHandleFromUrl(target.href),
        source: 'quiz_result'
      });
      return;
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form) return;
    if (form.id === 'cfh-popup-form' || form.querySelector('input[name="contact[email]"]')) {
      track('cfh_email_signup_submit', {
        source: form.id === 'cfh-popup-form' ? 'popup' : 'inline_form',
        has_email: !!form.querySelector('input[type="email"]')?.value
      });
    }
  }, true);

  function observe(selector, eventName, payloadFactory) {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(selector));
    if (!nodes.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var key = eventName + ':' + selector + ':' + (entry.target.id || entry.target.className || textOf(entry.target));
        fireOnce(key, eventName, payloadFactory ? payloadFactory(entry.target) : {});
        io.unobserve(entry.target);
      });
    }, { threshold: 0.35 });
    nodes.forEach(function (node) { io.observe(node); });
  }

  function boot() {
    fireOnce('page:' + window.location.pathname, 'cfh_page_view', { template: document.querySelector('main')?.dataset.template || '' });
    observe('.cfh-pdp-proof', 'cfh_pdp_proof_view', function () { return { product_handle: productHandleFromUrl(window.location.href) }; });
    observe('.cfh-live-quiz--intro', 'cfh_quiz_intro_view', function () { return { source: 'find_my_coffee' }; });
    observe('.cfh-cart-confidence', 'cfh_cart_confidence_view', function () { return { source: 'cart_drawer' }; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('pageshow', boot);
})();
